// extracted by mini-css-extract-plugin
export default {"button":"AppButtons_button__RGqO6 layout_flex_center__d71C-","icon":"AppButtons_icon__KwABU","bigText":"AppButtons_bigText__iZQNs","smallText":"AppButtons_smallText__6jkQd"};